"use client";

import {
	createContext,
	type ReactNode,
	useCallback,
	useContext,
	useMemo,
	useState,
} from "react";

interface RecognitionBusyValue {
	/** Идёт распознавание документа — поля формы заблокированы (t_aba782d3). */
	busy: boolean;
	setBusy: (busy: boolean) => void;
}

const RecognitionBusyContext = createContext<RecognitionBusyValue | null>(null);

/**
 * Провайдер блокировки формы на время распознавания загруженного документа.
 * Пока распознавание идёт, поля заполнять нельзя (иначе значения перезапишутся
 * результатом распознавания), поэтому файловое поле сообщает о старте/окончании.
 */
export function RecognitionBusyProvider({ children }: { children: ReactNode }) {
	const [busy, setBusyState] = useState(false);
	const setBusy = useCallback((next: boolean) => setBusyState(next), []);
	const value = useMemo(() => ({ busy, setBusy }), [busy, setBusy]);

	return (
		<RecognitionBusyContext.Provider value={value}>
			{children}
		</RecognitionBusyContext.Provider>
	);
}

/** Состояние распознавания; null — рендер вне провайдера (превью, конструктор). */
export const useRecognitionBusy = (): RecognitionBusyValue | null =>
	useContext(RecognitionBusyContext);
